import ajax from '@/resources/myApi';
import vm from '@/main';

const service = {
  getEmailTemplate,
  manageEmailTemplate,
  deleteEmailTemplate,
};

async function getEmailTemplate() {
  try {
    const { data } = await ajax.get(`api/EmailTemplate`, {
      name: 'EmailTemplate',
      params: { pageNumber: 0, pageSize: 1 },
    });
    return data.items;
  } catch (error) {
    if (error.response && error.response.status < 500) {
      vm.$snotify.error('EmailTemplate not found');
    }
    return {};
  }
}

async function manageEmailTemplate(dto) {
  try {
    if (dto.id) {
      var { data } = await ajax.put(`api/EmailTemplate/${dto.id}`, {
        name: 'EmailTemplate',
        body: dto,
      });
    } else {
      var { data } = await ajax.post(`api/EmailTemplate`, {
        name: 'EmailTemplate',
        body: dto,
      });
    }

    if (data.id) {
      vm.$snotify.success((dto.id) ? 'EmailTemplate changes saved' : 'EmailTemplate has been created', 'EmailTemplate');

      return data.id;
    }
  } catch (error) {
    throw error;
  }
}

async function deleteEmailTemplate(id) {
  try {
    await ajax.delete(`api/EmailTemplate/${id}`);
    vm.$snotify.success('EmailTemplate has been removed', 'EmailTemplate');
  } catch {
  }
}

export default service;
